import { createClient } from '@supabase/supabase-js';
import { debugLog } from './debugLog';

const url = process.env.REACT_APP_SKINNY_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SKINNY_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error('Missing Supabase env vars: REACT_APP_SKINNY_SUPABASE_URL and REACT_APP_SKINNY_SUPABASE_ANON_KEY');
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  },
});

export function debugSupabaseConfigOnce() {
  if (process.env.NODE_ENV !== 'development') return;
  try {
    const u = process.env.REACT_APP_SKINNY_SUPABASE_URL;
    const k = process.env.REACT_APP_SKINNY_SUPABASE_ANON_KEY || '';
    debugLog('[Supabase/ENV] URL:', u);
    debugLog('[Supabase/ENV] anon key:', k ? `${k.slice(0,8)}… (len=${k.length})` : 'MISSING');
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[Supabase/ENV] error', e);
  }
}

// Debug helper (optional use):
export async function debugSupabaseSession(label = 'debug') {
  try {
    const { data } = await supabase.auth.getSession();
    debugLog(`[Supabase ${label}] session`, { hasSession: !!data?.session });
  } catch (e) {
    debugLog(`[Supabase ${label}] getSession error`, e);
  }
}
